import React from "react"
import { Outlet } from "react-router-dom"
import Navbar from "../components/Navbar"
import avatarIcon from "../assets/icons/avatar.svg"

export default function DocumentEditorLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar name="Dr. Bridgette" profileUrl={avatarIcon} />

      <div className="lg:flex lg:flex-1">
        <main className="flex-1 bg-bgColor md:px-[50px] p-6 min-w-0">
          {/* For simple wrap usage */}
          {children}

          {/* For nested route usage */}
          <Outlet />
        </main>
      </div>
    </div>
  )
}
